import React from "react";
import PropTypes from "prop-types";
import * as generalFunctions from "../../common/utils/generalFunctions";

export const EditDraftOrderConfirmation = (props) => {
  const { headerId, shipDate, deliveryDate, printButtonHandler, shipDateVisible, deliveryDateVisible, actionType } = props;
  const shouldRenderRequestedDates = actionType !== 'cancel-order';

  const getConfirmationHeader = () => {
    switch (actionType) {
      case 'approve-submit':
        return 'Order Submitted';
      case 'cancel-order':
        return 'Order Cancelled';
      case 'save-draft':
      default:
        return 'Draft Order Saved';
    }
  };

  const getConfirmationMessage = () => {
    switch (actionType) {
      case 'approve-submit':
        return `Order No. ${headerId} has been approved and submitted`;
      case 'cancel-order':
        return `Order No. ${headerId} has been cancelled`;
      case 'save-draft':
      default:
        return `Draft Order No. ${headerId} has been updated.`;
    }
  };

  return (
    <div className="panel panel-default height_100percent" id="orderConfirmation">
      <div className="panel-heading">{getConfirmationHeader()}</div>
      <div className="panel-body order-summary">
        <div className="col-sm-12">
          <p id="confirmation">
            {getConfirmationMessage()}
          </p>
          {shouldRenderRequestedDates && shipDateVisible &&
            <div>Your requested ship date is {generalFunctions.getFormattedDisplayDate(shipDate)}.</div>}
          {shouldRenderRequestedDates && deliveryDateVisible &&
            <p>Your requested arrival date is {generalFunctions.getFormattedDisplayDate(deliveryDate)}.</p>}
          <p>
            Please click the Print Order button to print or export the current order.
          </p>
        </div>

        <span className="col-md-12"><hr /></span>

        <div className="pull-right">
          <button className="btn btn-primary" id="printOrder" onClick={() => printButtonHandler && printButtonHandler(headerId)}>
            Print Order
          </button>
        </div>
      </div>
    </div>
  );
};

EditDraftOrderConfirmation.propTypes = {
  headerId: PropTypes.number,
  shipDate: PropTypes.string,
  deliveryDate: PropTypes.string,
  shipDateVisible: PropTypes.bool,
  deliveryDateVisible: PropTypes.bool,
  actionType: PropTypes.string,
  printButtonHandler: PropTypes.func
};
